export var defaultOpts = {
    navCtrl: true,
    scaleCtrl: true,
    overviewCtrl: true,
    enableScrollWheelZoom: true,
    geolocationCtrl: false,
    zoom: 10
};
export var defaultOfflineOpts = {
    retryInterval: 30000,
    txt: 'OFFLINE'
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/defaults.js
// module id = ../../../../._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/defaults.js
// module chunks = 5